import {
  DEFAULT_EXPIRY_THRESHOLD_MONTHS,
  EXPIRY_THRESHOLD_PRESET_MONTHS,
  applyExpiryFlagsToGroupedProducts,
  formatExpiryThresholdLabel,
  getMedicineExpiryStatus,
  isExpiredExpiryDate,
  isNearExpiryDate,
  monthsToThresholdDays,
  parseExpiryThresholdMonths,
} from "./medicineExpiryThreshold";

export {
  DEFAULT_EXPIRY_THRESHOLD_MONTHS,
  EXPIRY_THRESHOLD_PRESET_MONTHS,
  applyExpiryFlagsToGroupedProducts,
  formatExpiryThresholdLabel,
  isExpiredExpiryDate,
  isNearExpiryDate,
  monthsToThresholdDays,
  parseExpiryThresholdMonths,
};

export const getPathExpiryStatus = getMedicineExpiryStatus;

export const getPathExpiryThresholdStorageKey = (organizationId) =>
  organizationId
    ? `hms_path_expiry_threshold_months_${organizationId}`
    : "hms_path_expiry_threshold_months_global";

export const readPathExpiryThresholdMonthsFromStorage = (organizationId) => {
  try {
    const stored = localStorage.getItem(getPathExpiryThresholdStorageKey(organizationId));
    if (stored == null || stored === "") return null;
    return parseExpiryThresholdMonths(stored, null);
  } catch {
    return null;
  }
};

export const writePathExpiryThresholdMonthsToStorage = (organizationId, months) => {
  const safe = parseExpiryThresholdMonths(months);
  localStorage.setItem(getPathExpiryThresholdStorageKey(organizationId), String(safe));
  return safe;
};

export const PATH_EXPIRY_THRESHOLD_CHANGED = "hms-path-expiry-threshold-changed";

export const notifyPathExpiryThresholdChanged = (months) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(PATH_EXPIRY_THRESHOLD_CHANGED, {
      detail: { months: parseExpiryThresholdMonths(months) },
    })
  );
};
